import React from 'react';

const Hero = () => {
  const scrollToSection = (e, sectionId) => {
    e.preventDefault();
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="home" className="hero">
      <div className="container hero-split">
        <div className="hero-text">
          <h1>CompileX — Engineering the Future of Intelligent Software</h1>
          <p>We build high-performance software across game development, AI & machine learning, generative AI, web and mobile platforms, and deep-tech research. From early-stage ideas to production-ready systems, CompileX turns complex problems into scalable solutions.</p>
          <div className="hero-btns">
            <a href="#contact" className="btn btn-primary" onClick={(e) => scrollToSection(e, 'contact')}>
              ➡️ Start a Project
            </a>
            <a href="#contact" className="btn btn-secondary" onClick={(e) => scrollToSection(e, 'contact')}>
              Book a Consultation
            </a>
          </div>
        </div>
        <div className="hero-illustration">
          <div className="hero-graphic">
            <svg viewBox="0 0 600 400" xmlns="http://www.w3.org/2000/svg">
              <defs>
                <linearGradient id="purpleGrad" x1="0%" y1="0%" x2="100%" y2="100%">
                  <stop offset="0%" style={{stopColor: '#9333EA', stopOpacity: 1}} />
                  <stop offset="100%" style={{stopColor: '#2563EB', stopOpacity: 1}} />
                </linearGradient>
              </defs>
              <circle cx="300" cy="200" r="80" fill="url(#purpleGrad)" opacity="0.3" />
              <rect x="200" y="150" width="100" height="100" rx="10" fill="url(#purpleGrad)" opacity="0.4" />
              <circle cx="400" cy="250" r="50" fill="#9333EA" opacity="0.5" />
              <rect x="250" y="100" width="80" height="60" rx="5" fill="#2563EB" opacity="0.4" />
              <circle cx="150" cy="300" r="40" fill="url(#purpleGrad)" opacity="0.6" />
              <rect x="350" y="180" width="70" height="70" rx="8" fill="#9333EA" opacity="0.3" />
            </svg>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
